import { fromPairs } from '@core/helpers'
import { experiments, rollouts } from '@flags/config'
import { getOnlyFlagsWithPrefix } from '@flags/utils'

/**
 * Returns a subset of the flags state object, containing only the flags
 * that match the given prefix. And the prefix is removed from the flag name.
 * @param { any } stateFlagsSubset Flags state object subset
 * @param { Prefix } prefix flag prefix as defined in the naming convention
 * @returns { any } subset of the flags state object
 */
const trimPrefixFromFlags = (stateFlagsSubset, prefix) => {
  const pairs = Object.entries(stateFlagsSubset).map(([key, value]) => {
    return [key.replace(`${prefix}.`, ''), value]
  })

  return fromPairs(pairs)
}

export default {
  namespaced: true,
  state() {
    return {
      experiments: {},
      rollouts: {},
    }
  },
  getters: {
    getExperiments: (state) => {
      return trimPrefixFromFlags(state.experiments, 'experiment')
    },
    getRollouts: (state) => {
      return trimPrefixFromFlags(state.rollouts, 'rollout')
    },
    isDefaultSegment: (state) => {
      const flags = { ...state.experiments, ...state.rollouts }
      const configuredFlags = { ...experiments, ...rollouts }

      const storedFlagsCount = Object.keys(flags).length
      const configuredFlagsCount = Object.keys(configuredFlags).length

      if (configuredFlagsCount !== storedFlagsCount) {
        return false
      }

      // Using forEach is more complex since we want the function to return.
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(flags)) {
        if (configuredFlags[key] !== value) {
          return false
        }
      }

      return true
    },
    // This is probably not what you are looking for. If you want to consume
    // flags from a Vue component or another Vuex store module, you have
    // to use the getExperiments or getRollouts getters instead.
    getOriginalFlags: (state) => ({ ...state.experiments, ...state.rollouts }),
  },
  mutations: {
    setFlags(state, payload) {
      state.experiments = getOnlyFlagsWithPrefix(payload, 'experiment')
      state.rollouts = getOnlyFlagsWithPrefix(payload, 'rollout')
    },
  },
  actions: {
    load({ commit }, payload = {}) {
      const flags = { ...experiments, ...rollouts, ...payload }
      commit('setFlags', flags)
    },
  },
}
